<template>
    <div class="contents_wrap" style="min-height: calc(100% - 60px); display: flex;">
        <section>
            <div class="login_wrap step3">
                <h3 class="set">{{label1}}<br>{{this.$t('MSG_TXT_AICC_START_SIP_LABEL_3')}}</h3>
                <div class="box_gray">
                    <ul class="ulist">
                        <li>
                            <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_1')}}</strong>
                            <span style="width:69px">{{aiccInfo.contactCenterName}}</span>
                        </li>
                        <li>
                            <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_2')}}</strong>
                            <span>{{contactCenterUrl}}</span>
                        </li>
                        <li>
                            <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_3')}}</strong>
                            <span style="width:52px">{{aiccInfo.contactCenterPrice}}</span>
                        </li>
                        <li>
                            <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_4')}}</strong>
                            <span class="link" @click="onClickSipNumber">{{sipNumberSummary}}</span>
                        </li>
                    </ul>
                </div>
                <h4 v-html="guide1"></h4>
                <div class="box_common">
                    <ul>
                        <li>{{this.$t('MSG_TXT_AICC_START_SIP_GUIDE_4')}}<ur-button class="btn_download" @click="onClickDownloadButton" :text="$t('MSG_BTN_CHANGE_APPLICATION_DOWNLOAD')"/></li>
                        <li>
                            {{$t('MSG_TXT_AICC_START_SIP_GUIDE_5')}}
                            <ul>
                                <li><span class="num1"/><span style="font-size:12px; color:#333">{{$t('MSG_TXT_AICC_START_SIP_GUIDE_6')}}</span></li>
                                <li><span class="num2"/><span style="font-size:12px; color:#333">{{$t('MSG_TXT_AICC_START_SIP_GUIDE_8')}}</span></li>
                            </ul>
                        </li>
                        <li>{{$t('MSG_TXT_AICC_START_SIP_GUIDE_9')}}</li>
                    </ul>
                </div>
            </div>
            <div class="btn_wrap">
                <ur-button :text="$t('MSG_BTN_START')" large solid primary @click="onClickStart"/>
            </div>
            <modal ref="modal" :list="propsList"/>
        </section>
    </div>
<!--
    <div class="contents_wrap">
        <div class="login_wrap step3">
            <h3 class="set">{{label1}}<br>{{this.$t('MSG_TXT_AICC_START_SIP_LABEL_3')}}</h3>
            <div class="box_gray">
                <div class="contents" style="width:80px;">
                    <div class="label" >{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_1')}}</div>
                    <div class="value">{{aiccInfo.contactCenterName}}</div>
                </div>
                <div class="divider"/>
                <div class="contents" style="width:290px;">
                    <div class="label">{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_2')}}</div>
                    <div class="value">{{contactCenterUrl}}</div>
                </div>
                <div class="divider"/>
                <div class="contents" style="width:52px;">
                    <div class="label">{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_3')}}</div>
                    <div class="value">{{aiccInfo.contactCenterPrice}}</div>
                </div>
                <div class="divider"/>
                <div class="contents" >
                    <div class="label">{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_4')}}</div>
                    <div class="value"><span @click="onClickSipNumber">{{sipNumberSummary}}</span></div>
                </div>
                /*
                <ul class="ulist">
                    <li>
                        <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_1')}}</strong>
                        <span>{{aiccInfo.contactCenterName}}</span>
                    </li>
                    <li class="url">
                        <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_2')}}</strong>
                        <span>{{contactCenterUrl}}</span>
                    </li>
                    <li>
                        <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_3')}}</strong>
                        <span>{{aiccInfo.contactCenterPrice}}</span>
                    </li>
                    <li>
                        <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_4')}}</strong>
                        <span><a @click="onClickSipNumber">{{sipNumberSummary}}</a></span>
                    </li>
                </ul>
                */
            </div>
            <h4 v-html="guide1"/>
            <div class="box_common">
                <div class="guide">
                    {{$t('MSG_TXT_AICC_START_SIP_GUIDE_4')}}
                    <ur-button class="btn_download" @click="onClickDownloadButton" :text="$t('MSG_BTN_CHANGE_APPLICATION_DOWNLOAD')"/>
                </div>
                <div class="guide" style="display:flex; align-items:center">
                    {{$t('MSG_TXT_AICC_START_SIP_GUIDE_5')}}
                    <i class="img_num_1"/>
                    <span class="small">{{$t('MSG_TXT_AICC_START_SIP_GUIDE_6')}}</span>
                    <i class="img_num_2"/>
                    <span class="small">{{$t('MSG_TXT_AICC_START_SIP_GUIDE_8')}}</span>
                </div>
                <div class="guide">
                    {{$t('MSG_TXT_AICC_START_SIP_GUIDE_9')}}
                </div>
                /*
                <ul>
                    <li style="font-size:14px; font-weight:500; color:#333;">{{$t('MSG_TXT_AICC_START_SIP_GUIDE_4')}}
                        <ur-button class="btn_download" small :text="$t('MSG_BTN_CHANGE_APPLICATION_DOWNLOAD')" primary/>
                    </li>
                    <li style="font-size:14px; font-weight:500; color:#333;">{{$t('MSG_TXT_AICC_START_SIP_GUIDE_5')}}
                        <ul>
                            <li><i class="img_num_1"/><span style="font-size:12px; color:#333">{{$t('MSG_TXT_AICC_START_SIP_GUIDE_6')}}</span></li>
                            <li><i class="img_num_2"/><span style="font-size:12px; color:#333">{{$t('MSG_TXT_AICC_START_SIP_GUIDE_8')}}</span></li>
                        </ul>
                    </li>
                    <li style="font-size:14px; font-weight:500; color:#333;">{{$t('MSG_TXT_AICC_START_SIP_GUIDE_9')}}</li>
                </ul>
                */
            </div>
            <div class="btn_wrap">
                <ur-button :text="$t('MSG_BTN_START')" large solid primary @click="onClickStart"/>
            </div>
        </div>
        <modal ref="modal" :list="propsList"/>
    </div>
    -->
</template>
<script>
import modal from './components/PGE_AIM_00004_P01';
export default {
    name:'PGE_AIM_00004',
    components:{
        modal,
    },
    data() {
        return {
            aiccInfo:{
                contactCenterName:'',
                contactCenterUrl:'',
                contactCenterPrice:'',
            },
            sipNumberList:[],
        }
    },
    created(){
    },
    mounted(){
        this.$store.commit('hideGnbMenu');
        this.getAICCInfo();
        this.getSipNumberList();
    },
    computed:{
        contextPageId() {
            if (this._props._params && this._props._params.routerOriginPageId) {
                return this._props._params.routerOriginPageId;
            }
            if(this.$options.name.length > 13) {
                return this.$options.name.substr(0,13);
            }
            return this.$options.name;
        },
        label1(){
            let result;
            result = this.$t('MSG_TXT_AICC_START_SIP_LABEL_2').replace('%(%S1)', this.aiccInfo.contactCenterName);
            return result;
        },
        contactCenterUrl(){
            let result;
            result = this.$t('MSG_TXT_AICC_BASE_URL') + this.aiccInfo.contactCenterUrl;
            return result;
        },
        guide1(){
            let result;
            result = this.$t('MSG_TXT_AICC_START_SIP_GUIDE_2').replace('%(%S1)', this.$t('MSG_TXT_AICC_START_SIP_GUIDE_3'))
            return result;
        },
        sipNumberSummary(){
            let result = '';
            let totalSipNumber = 0;
            let totalChannels = 0;
            let temp;

            if(this.sipNumberList && this.sipNumberList.length > 0) {
                for(let index in this.sipNumberList) {
                    if(!temp) {
                        temp = this.sipNumberList[index].sipNumber;
                    }
                    totalSipNumber++;
                    totalChannels += this.sipNumberList[index].channels;
                }
                if(totalSipNumber > 1) {
                    result = this.$t('MSG_TXT_AICC_START_SIP_INFO_FORMAT_2');
                } else {
                    result = this.$t('MSG_TXT_AICC_START_SIP_INFO_FORMAT_1');
                }
                result = result.replace('%(%S1)', aiccUtils.phoneNumberFormat.format(temp)).replace('%(%S2)', totalChannels).replace('%(%S3)', totalSipNumber - 1);
            } else {
                result = '';
            }
            return result;
        },
        propsList(){
            return this.sipNumberList;
        },
    },
    methods:{
        getAICCInfo(){
            http.request(this.contextPageId, 'DTS_AIM_00001' , {})
                .then(res => {
                    this.aiccInfo.contactCenterName = res.data.aiccInfo.contactCenterNm;
                    this.aiccInfo.contactCenterUrl = res.data.aiccInfo.contactCenterUrl;
                    this.aiccInfo.contactCenterPrice = '스탠다드';
                })
                .catch(error => {

                })
        },
        getSipNumberList(){
            http.request(this.contextPageId, 'DTS_AIS_00003', {
                path: {
                    'type':'listCCRequest',
                }
            }).then(res => {
                this.sipNumberList = [];
                for(let index in res.data.sipNumberList) {
                    this.sipNumberList.push(res.data.sipNumberList[index]);
                }
            }).catch(error => {

            })
        },
        onClickSipNumber(){
            this.$refs['modal'].open();
        },
        onClickDownloadButton(){
            http.request(this.contextPageId, 'DTS_AIM_00011', {
                path:{
                    'file-id':'302FE222-5673-11EC-A59F-0050569345CE',
                }
            }).then(res => {
                if(res.status === 200 && res.data.file ) {
                    const fileBase64 = res.data.file.file;
                    const fileName = res.data.file.fileName;
                    try {
                        aiccUtils.fileDownload.downloadBase64(fileBase64, fileName, 'application/pdf');
                    } catch {
                        utils.aiccMessageBox('확인', '파일 다운로드 중 에러가 발생했습니다.', '확인', null, null, null);
                    }
                } else {
                    utils.aiccMessageBox('확인', '파일 다운로드 중 에러가 발생했습니다.', '확인', null, null, null);
                }
            })
        },
        onClickStart(){
            utils.goHome();
        },
    },

}
</script>
<style scoped>
    section {
        width: 100%;
    }
    .box_gray {
        margin: 0;
        margin-top: -1px;
    }
    .login_wrap.step3 .box_gray .ulist li:first-child {
        flex-basis: unset;
    }
    .login_wrap.step3 .box_gray .ulist li:nth-child(2) {
        flex-basis: 38.75%;
    }
    .login_wrap.step3 .box_gray .ulist li:nth-child(3) {
        flex-basis: unset;
    }
    .login_wrap.step3 .box_gray .ulist li:nth-child(4) {
        flex-basis: 27.75%;
    }
    .link {
        cursor: pointer;
    }
    .box_common {
        border: solid 1px #EAEAEA;
        background-color: #EFF1F8;
        margin-top: 16px;
        padding: 28px 48px;
    }
    .box_common li + li {
        margin-top: 12px;
    }
    .box_common > ul ul {
        display: inline-block;
        vertical-align: top;
        font-size: 0;
    }
    .box_common > ul ul li {
        margin-top: 0;
        vertical-align: top;
        display: inline-block;
        margin-left: 12px;
    }
    .box_common .btn_download {
        display: inline;
        width: 120px;
        height: 24px;
        margin: 0 0 0 12px;
        padding: 3px 8px;
        border-radius: 2px;
        border: solid 1px #8B9ABC;
        background-color: #FFF;
        font-family: 'NotoSansCJKkr' !important;
        font-size: 11.9px;
        font-weight: normal;
        font-stretch: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #555;
    }
    span.num1 {
        display: inline-block;
        background: url('../../../../assets/images/aicc/number_1.png') no-repeat;
        width: 16px;
        height: 16px;
        margin-top: 1px;
        margin-right: 4px;
    }
    span.num2 {
        display: inline-block;
        background: url('../../../../assets/images/aicc/number_2.png') no-repeat;
        width: 16px;
        height: 16px;
        margin-top: 1px;
        margin-right: 4px;
    }
/*
    .contents_wrap {
        font-family: 'Noto Sans KR';
    }

    h3 {
        text-align: center;
    }
    h4 {
        margin-top: 52px;
        text-align: center;
    }
    .box_gray {
        margin: 0;
        padding: 18px 4px;
        display: flex;
        border-radius: 4px;
        border: solid 1px #eaeaea;
        background-color: #f7f7f7;
    }
    .box_gray .contents {
        margin-left: 20px;
        margin-right: 20px
    }
    .box_gray .contents .label {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.83;
        letter-spacing: normal;
        text-align: left;
        color: #767676;
    }
    .box_gray .contents .value {
        margin-top: 6px;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #333;
        word-break: break-all;
    }
    .box_gray .contents .value span{
        text-decoration: underline;
    }
    .box_gray .divider {
        width:1px;
        background-color: #ddd;
        cursor: pointer;
    }


    h4 {
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #333;
    }
    .box_common {
        font-family: 'Noto Sans KR';
        margin-top: 16px;
        padding: 21px 40px;
        border: 1px solid #eaeaea;
        background-color: #EFF1F8;
    }
    .box_common .guide {
        padding: 7px 0;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: normal;
        text-align: left;
        color: #333;
    }
    .box_common .guide .small{
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 2;
        letter-spacing: normal;
        text-align: left;
        color: #333;
    }



    .box_common > ul {
        padding: 16px 24px;
    }
    .box_common > ul li + li {
        margin-top: 14px;
    }
    .box_common > ul ul {
        display: inline-block;
        vertical-align: top;
    }
    .box_common > ul ul li {
        margin-top: 0;
        vertical-align: top;
        display: inline-block;
        margin-left: 12px;
    }
    .box_common > ul ul li span {
        font-size: 12px;
        vertical-align: top;
    }
    .num1 {
        display: inline-block;
        width:16px;
        height:16px;
        font-size: 0;
        line-height: 0;
        vertical-align: top;
        margin-top: 1px;
        margin-right: 4px;
    }
    .num2 {
        display: inline-block;
        width:16px;
        height:16px;
        font-size: 0;
        line-height: 0;
        vertical-align: top;
        margin-top: 1px;
        margin-right: 4px;
    }
    .btn_wrap {
        margin: 60px 0 0;
        text-align: center;
    }
    .ur-button--medium {
        padding: 8px 3px;
    }
    .btn_download {
        color: #555;
        margin-left:12px;
        width: 120px;
        height: 24px;
        background: #FFF;
        font-size: 12px;
    }
    i {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-left: 12px;
        margin-right: 4px;
    }
    .img_num_1 {
        background: url('../../../../assets/images/aicc/number_1.png');
    }
    .img_num_2 {
        background: url('../../../../assets/images/aicc/number_2.png');
    }
    */
</style>